export class BaseEditComponent {
  public loading: boolean;
  public loaded: boolean;
  public pageLoading: boolean;
  public editMode: boolean;

  get isInitialLoading() {
    return this.pageLoading || (this.loading && !this.loaded);
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/core/common/base-component.ts